import { useAxiosCreate } from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header'

/**
 * GET /api/v2/cars/list
 * @returns {Promise<object>}
 */
export function fetchCarsList(params = {}, { signal } = {}) {
  const api = useAxiosCreate('api')
  return api
    .get('cars/list', {
      params,
      signal,
      headers: authHeader(),
    })
    .then((res) => res.data)
}

/**
 * GET /api/v2/cars/{id}
 * @returns {Promise<object>}
 */
export function fetchCarById(carId, { signal } = {}) {
  const api = useAxiosCreate('api')
  return api
    .get(`cars/${carId}`, {
      signal,
      headers: authHeader(),
    })
    .then((res) => res.data)
}
